<template>
  <div class="home">

    <!-- Terminal-style content -->
    <div class="terminal-container">


      <!-- Header -->
      <header class="terminal-header">
        <div class="terminal-prompt">
          <span class="prompt-user">xoul</span><span class="prompt-at">@</span><span class="prompt-host">local</span>
          <span class="prompt-colon">:</span><span class="prompt-path">~</span><span class="prompt-dollar">$</span>
          <span class="prompt-cmd">cat README.md</span>
          <span class="cursor">▊</span>
        </div>
      </header>

      <!-- Project Title -->
      <section class="section readme-hero">
        <h1 class="project-name">
          <span class="bracket">[</span> Xoul <span class="bracket">]</span>
        </h1>
        <p class="project-tagline" v-html="$t('hero.subtitle')"></p>
        <div class="badges">
          <span class="badge badge-green" v-for="(b, i) in $tm('hero.badges')" :key="i">{{ b }}</span>
        </div>
      </section>

      <!-- Divider -->
      <div class="terminal-divider">
        <span>── {{ $t('values.title_highlight') }} ──</span>
      </div>

      <!-- Core Principles -->
      <section class="section">
        <div class="principles-grid">
          <div class="principle-item" v-for="(item, idx) in valueItems" :key="idx">
            <span class="principle-icon">{{ item.icon }}</span>
            <div>
              <div class="principle-title">{{ item.title }}</div>
              <div class="principle-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Modules -->
      <div class="terminal-divider">
        <span>── modules ──</span>
      </div>

      <section class="section modules-section">

        <!-- Workflow Hub -->
        <div class="module-block">
          <div class="module-header">
            <span class="module-icon">🔄</span>
            <h2 class="module-name">{{ $t('home_features.workflows.title') }}</h2>
          </div>
          <p class="module-desc">{{ $t('home_features.workflows.desc') }}</p>
          <ul class="module-list">
            <li v-for="(h, i) in $tm('home_features.workflows.highlights')" :key="i">{{ h }}</li>
          </ul>
          <router-link to="/workflows" class="module-link">
            → {{ $t('home_features.workflows.cta') }}
          </router-link>
        </div>

        <!-- Persona Hub -->
        <div class="module-block">
          <div class="module-header">
            <span class="module-icon">🎭</span>
            <h2 class="module-name">{{ $t('home_features.personas.title') }}</h2>
          </div>
          <p class="module-desc">{{ $t('home_features.personas.desc') }}</p>
          <ul class="module-list">
            <li v-for="(h, i) in $tm('home_features.personas.highlights')" :key="i">{{ h }}</li>
          </ul>
          <router-link to="/personas" class="module-link">
            → {{ $t('home_features.personas.cta') }}
          </router-link>
        </div>

        <!-- Code Hub -->
        <div class="module-block">
          <div class="module-header">
            <span class="module-icon">🐍</span>
            <h2 class="module-name">{{ $t('home_features.codes.title') }}</h2>
          </div>
          <p class="module-desc">{{ $t('home_features.codes.desc') }}</p>
          <ul class="module-list">
            <li v-for="(h, i) in $tm('home_features.codes.highlights')" :key="i">{{ h }}</li>
          </ul>
          <router-link to="/codes" class="module-link">
            → {{ $t('home_features.codes.cta') }}
          </router-link>
        </div>

        <!-- AI Arena -->
        <div class="module-block">
          <div class="module-header">
            <span class="module-icon">⚔️</span>
            <h2 class="module-name">{{ $t('home_features.arena.title') }}</h2>
          </div>
          <p class="module-desc">{{ $t('home_features.arena.desc') }}</p>
          <ul class="module-list">
            <li v-for="(h, i) in $tm('home_features.arena.highlights')" :key="i">{{ h }}</li>
          </ul>
          <router-link to="/arena" class="module-link">
            → {{ $t('home_features.arena.cta') }}
          </router-link>
        </div>

      </section>

      <!-- Stats -->
      <div class="terminal-divider">
        <span>── stats ──</span>
      </div>

      <section class="section stats-section">
        <div class="stat-row">
          <span class="stat-key">codes</span>
          <span class="stat-dots"></span>
          <span class="stat-val">50+</span>
        </div>
        <div class="stat-row">
          <span class="stat-key">personas</span>
          <span class="stat-dots"></span>
          <span class="stat-val">40+</span>
        </div>
        <div class="stat-row">
          <span class="stat-key">workflows</span>
          <span class="stat-dots"></span>
          <span class="stat-val">40+</span>
        </div>
        <div class="stat-row">
          <span class="stat-key">tools</span>
          <span class="stat-dots"></span>
          <span class="stat-val">18</span>
        </div>
        <div class="stat-row">
          <span class="stat-key">privacy</span>
          <span class="stat-dots"></span>
          <span class="stat-val">100% on-premise</span>
        </div>
      </section>

      <!-- Footer -->
      <footer class="terminal-footer">
        <div class="terminal-prompt">
          <span class="prompt-user">xoul</span><span class="prompt-at">@</span><span class="prompt-host">local</span>
          <span class="prompt-colon">:</span><span class="prompt-path">~</span><span class="prompt-dollar">$</span>
          <span class="cursor blink">▊</span>
        </div>
        <div class="footer-text">{{ $t('footer.brand') }}</div>
      </footer>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  computed: {
    valueItems() {
      return this.$tm('values.items')
    },
  },

}
</script>

<style scoped>
/* ── Global ── */
.home {
  position: relative;
  min-height: 100vh;
  background: transparent;
  color: #b0b0b0;
  font-family: 'Fira Code', 'Cascadia Code', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.6;
}

/* ── Code Rain Canvas (now in App.vue) ── */

/* ── Terminal Container ── */
.terminal-container {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  padding: 24px 32px 40px;
}

/* ── Terminal Prompt ── */
.terminal-header {
  margin-bottom: 32px;
  padding-top: 12px;
}

.terminal-prompt {
  font-size: 15px;
  letter-spacing: 0.5px;
}

.prompt-user { color: #50c878; }
.prompt-at { color: #555; }
.prompt-host { color: #50c878; }
.prompt-colon { color: #555; }
.prompt-path { color: #6a9fb5; }
.prompt-dollar { color: #555; margin-right: 8px; }
.prompt-cmd { color: #e0e0e0; }

.cursor {
  color: #50c878;
  opacity: 0.8;
}

.cursor.blink {
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* ── Section ── */
.section {
  margin-bottom: 24px;
}

/* ── README Hero ── */
.readme-hero {
  margin-bottom: 24px;
  background: rgba(8, 8, 8, 0.80);
  padding: 24px;
  border-radius: 8px;
}

.project-name {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 900;
  color: #50c878;
  letter-spacing: 2px;
  margin-bottom: 16px;
  text-shadow: 0 0 30px rgba(80, 200, 120, 0.3);
}

.bracket {
  color: #3a6a4a;
  font-weight: 400;
}

.project-tagline {
  color: #888;
  font-size: 15px;
  line-height: 1.8;
  margin-bottom: 20px;
}

.project-tagline :deep(br) {
  display: block;
  content: '';
  margin-top: 4px;
}

.badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge {
  display: inline-block;
  padding: 3px 12px;
  border: 1px solid rgba(80, 200, 120, 0.3);
  border-radius: 4px;
  font-size: 11px;
  color: #50c878;
  letter-spacing: 0.5px;
}

.badge-green {
  border-color: rgba(80, 200, 120, 0.3);
  color: #50c878;
}

/* ── Terminal Divider ── */
.terminal-divider {
  color: #333;
  font-size: 12px;
  margin: 24px 0 20px;
  letter-spacing: 1px;
}

.terminal-divider span {
  color: #444;
}

/* ── Principles ── */
.principles-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.principle-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 10px 16px;
  border-left: 2px solid #1a1a1a;
  transition: border-color 0.3s;
  background: rgba(8, 8, 8, 0.80);
  border-radius: 0 6px 6px 0;
}

.principle-item:hover {
  border-left-color: #50c878;
}

.principle-icon {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

.principle-title {
  color: #d0d0d0;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 4px;
}

.principle-desc {
  color: #666;
  font-size: 13px;
  line-height: 1.6;
}

/* ── Modules ── */
.modules-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.module-block {
  padding: 18px 20px;
  border: 1px solid #1a1a1a;
  border-radius: 8px;
  background: rgba(8, 8, 8, 0.80);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.module-block:hover {
  border-color: rgba(80, 200, 120, 0.2);
  box-shadow: 0 0 30px rgba(80, 200, 120, 0.03);
}

.module-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.module-icon {
  font-size: 24px;
}

.module-name {
  font-size: 18px;
  font-weight: 700;
  color: #e0e0e0;
}

.module-desc {
  color: #777;
  font-size: 13px;
  margin-bottom: 14px;
  line-height: 1.6;
}

.module-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
}

.module-list li {
  color: #888;
  font-size: 13px;
  padding: 3px 0;
  line-height: 1.5;
}

.module-list li::before {
  content: '›';
  color: #50c878;
  margin-right: 10px;
  font-weight: bold;
}

.module-link {
  display: inline-block;
  color: #50c878;
  font-size: 13px;
  text-decoration: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  letter-spacing: 0.3px;
}

.module-link:hover {
  opacity: 1;
  color: #50c878;
  text-decoration: underline;
}

/* ── Stats ── */
.stats-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(8, 8, 8, 0.80);
  padding: 16px 20px;
  border-radius: 8px;
}

.stat-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
}

.stat-key {
  color: #666;
  min-width: 100px;
}

.stat-dots {
  flex: 1;
  border-bottom: 1px dotted #222;
  margin-bottom: 3px;
}

.stat-val {
  color: #50c878;
  font-weight: 600;
}

/* ── Footer ── */
.terminal-footer {
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #1a1a1a;
}

.footer-text {
  margin-top: 16px;
  color: #333;
  font-size: 12px;
  letter-spacing: 0.5px;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .terminal-container {
    padding: 16px 16px 24px;
  }

  .project-name {
    font-size: 2rem;
  }

  .stat-key {
    min-width: 80px;
  }
}
</style>
